import { useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, styled } from "@mui/material";
import { forwardRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";

export const SelectCity = forwardRef(
  ({ options: optionOverride, ...restProps }, ref) => {
    const _Cities = useSelector((state) => state.provinces.cities);
    const loading = useSelector((state) => state.provinces.loading);

    const options = optionOverride ?? _Cities.data ?? [];

    const GroupHeader = styled("div")(({ theme }) => ({
      position: "sticky",
      top: "-8px",
      padding: "4px 10px",
      borderBottom: "1px solid #e0e0e0",
      color: "white",
      backgroundColor: theme.palette.primary.main,
    }));
    const GroupItems = styled("ul")({
      padding: 0,
    });

    return (
      <Autocomplete
        ref={ref}
        options={options}
        {...restProps}
        getOptionLabel={(option) => {
          return option.name;
        }}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        renderInput={(params) => (
          <TextField
            required={restProps.required}
            error={restProps.error}
            helperText={restProps.helperText}
            {...params}
            label="اختر مدينة"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        renderGroup={(params, key) => (
          <li key={params.key}>
            <GroupHeader>{params.group}</GroupHeader>
            <GroupItems>{params.children}</GroupItems>
          </li>
        )}
      />
    );
  }
);
